import { BaseTextMergeElement } from "../BaseTextMergeElement";
import { TextMergeConfiguration } from "../../TextMergeConfiguration";
import { TextMergeType } from "../../TextMergeType";
import { ExecutionData } from "../../../Common/Data/ExecutionData/ExecutionData";
import { ITestingContext } from "../../../Common/Testing/ITestingContext";

export class HorizontalLineElement extends BaseTextMergeElement {
    readonly __type = "horizontallinebreak";
    readonly name = "Horizontal Line Break";
    readonly styleElement: boolean = true;
    readonly ordinal: number = 10;

    output(_data: ExecutionData, _config: TextMergeConfiguration, _textContext: ITestingContext | undefined): string {
        return "<hr/>";
    }

    canAdd(config: TextMergeConfiguration): boolean {
        return config.type === TextMergeType.HTML;
    }
}
